import React from 'react';
import OutlineTShirt from 'assets/svg/OutlineTShirt';
import OutlineTape from 'assets/svg/OutlineTape';
import CenterFocusWeakIcon from '@material-ui/icons/CenterFocusWeak';
import OutlineSpec from 'assets/svg/OutlineSpec';
import Image from 'components/Image';
import { ROUTES } from 'shared/constants/routes';
import {
  Container,
  ProductImage,
  DownloadResources,
  ResourceLink,
  Detail,
  Name,
  Download,
  StyledLink,
} from 'styles/pages/product-detail/productSummary';

const ProductSummary = ({ data }) => (
  <Container>
    <ProductImage>
      <Image
        src={data.Product?.MarketingImagePath}
        alt={`${data?.Product?.Name}`}
      />
    </ProductImage>
    <DownloadResources>
      <ResourceLink>
        <OutlineTShirt />
        <Detail target='_blank' href={data.Product?.MockupPath}>
          <Name>Mockup Template</Name>
          <Download>Download Template</Download>
        </Detail>
      </ResourceLink>

      <ResourceLink>
        <CenterFocusWeakIcon fontSize='large' />
        <StyledLink to={ROUTES.MY_STORES_PRODUCTS.LINK}>
          <Name>Mock-Up Generator</Name>
          <Download>Easy to Use</Download>
        </StyledLink>
      </ResourceLink>

      <ResourceLink>
        <OutlineTape />
        <Detail target='_blank' href={data.Product?.SizeChartPath}>
          <Name>Size Chart</Name>
          <Download>Download Size Chart</Download>
        </Detail>
      </ResourceLink>
      <ResourceLink>
        <OutlineSpec />
        <Detail target='_blank' href={data.Product?.ArtworkSpecsPath}>
          <Name>Get Artwork Specs</Name>
          <Download>Download Artwork Specs</Download>
        </Detail>
      </ResourceLink>
    </DownloadResources>
  </Container>
);

export default ProductSummary;
